import React, { useState } from "react";
import { Modal, Button, Checkbox } from "antd";
import { legalEntityAgreementContent } from "./agreement-content";

const agreementStyles = {
  content: {
    padding: "8px 4px 0",
  },
  scrollArea: {
    maxHeight: "55vh",
    overflowY: "auto",
    paddingRight: 8,
  },
  title: {
    fontSize: 22,
    lineHeight: "30px",
    textAlign: "center",
    fontWeight: 700,
    marginBottom: 16,
  },
  confirmText: {
    marginBottom: 12,
    lineHeight: "22px",
  },
  checkboxBlock: {
    borderTop: "1px solid #f0f0f0",
    paddingTop: 12,
  },
};

export default function ModalLegalEntityAgreement({ isShow, setIsShow, onAccepted }) {
  const [accepted, setAccepted] = useState(false);
  const [scrolledToEnd, setScrolledToEnd] = useState(false);

  const handleClose = () => {
    setAccepted(false);
    setIsShow(false);
  };

  const handleAccept = () => {
    setIsShow(false);
    setAccepted(false);
    if (onAccepted) {
      onAccepted();
    }
  };

  const handleScroll = (e) => {
    var el = e.target;
    var atEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    setScrolledToEnd(atEnd);
  };

  return (
      <Modal
          title={"Лицензионное соглашение"}
          cancelText={"Закрыть"}
          className="modal-window"
          align={null}
          visible={isShow}
          onCancel={handleClose}
          footer={[
            <Button key="close" onClick={handleClose}>
              Закрыть
            </Button>,
            <Button key="accept" type="primary" onClick={handleAccept} disabled={!accepted}>
              Принять
            </Button>,
          ]}
      >
        <div style={agreementStyles.content}>
          <div style={agreementStyles.scrollArea} onScroll={handleScroll}>
            <h1 style={agreementStyles.title}>{legalEntityAgreementContent.title}</h1>

            {/* Отображаем готовый JSX текст из termsConfig */}
            {legalEntityAgreementContent.text}

            <p style={agreementStyles.confirmText}>{legalEntityAgreementContent.confirmText}</p>
          </div>
          {scrolledToEnd ? (
              <div style={agreementStyles.checkboxBlock}>
                <Checkbox checked={accepted} onChange={(e) => setAccepted(e.target.checked)}>
                  {legalEntityAgreementContent.checkboxText}
                </Checkbox>
              </div>
          ) : null}
        </div>
      </Modal>
  );
}